module.exports = "<div ui-view>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/scrap/templates/index.html
// module id = 1597
// module chunks = 0